<template>
  <b-modal
    :title="this.isEdit ? 'Sửa nhóm chức vụ' : 'Thêm mới nhóm chức vụ'"
    @hidden="hideModal"
    centered
    no-close-on-backdrop
    ref="modalCapNhatNhomChucVu"
    size="md"
  >
    <validation-observer ref="observerNhomChucVu">
      <b-form>
        <validation-provider
          rules="code|required|maxlength:50"
          name="Mã nhóm chức vụ"
          v-slot="validationContext"
        >
          <b-form-group
            class="mb-4 required"
            id="maNhom-input-group"
            label="Mã nhóm chức vụ"
            label-for="maNhom-input"
            label-class="font-weight-bold"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              aria-describedby="tenNhom-live-feedback"
              class="border-radius-4"
              id="maNhom-input"
              name="maNhom-input"
              v-model="form.maNhom"
            ></b-form-input>
            <b-form-invalid-feedback id="maNhom-live-feedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider
          rules="required|maxlength:50"
          name="Nhóm chức vụ"
          v-slot="validationContext"
        >
          <b-form-group
            class="mb-4 required"
            id="tenNhom-input-group"
            label="Tên nhóm chức vụ"
            label-for="tenNhom-input"
            label-class="font-weight-bold"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              aria-describedby="tenNhom-live-feedback"
              class="border-radius-4"
              id="tenNhom-input"
              name="tenNhom-input"
              v-model="form.tenNhom"
            ></b-form-input>
            <b-form-invalid-feedback id="tenNhom-live-feedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
      <b-form-group
        class="mb-4"
        id="thuTu-input-group"
        label="Thứ tự"
        label-class="font-weight-bold"
        label-for="thuTu-input"
      >
        <b-form-input
          aria-describedby="thuTu-live-feedback"
          class="border-radius-4"
          id="thuTu-input"
          name="thuTu-input"
          type="number"
          v-model="form.thuTu"
        ></b-form-input>
      </b-form-group>
    </validation-observer>
    <template v-slot:modal-footer>
      <div class="d-flex">
        <base-button
          button="Lưu"
          @click="onSubmit()"
          class="btn btn-main ml-2"
          :disabled="isLoading"
        >
          {{ isEdit ? "Cập nhật" : "Thêm Mới" }}
        </base-button>
        <base-button button="Đóng" @click="hideModal()" class="btn btn-line">
          {{ BO_QUA_BUTTON_LABEL }}
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import { showMsgError } from "@/utils/commonUtils";
// import { isEmpty } from "lodash";

export default {
  name: "modalCapNhatNhomChucVu",
  props: {
    data: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      form: {
        tenNhom: "",
        maNhom: "",
        thuTu: null,
      },
      isLoading: false,
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    hideModal() {
      this.resetForm();
      this.$refs["modalCapNhatNhomChucVu"].hide();
      this.$emit("hidden");
    },
    resetForm() {
      this.form = {
        maNhom: "",
        tenNhom: "",
        thuTu: null,
      };
    },
    async onSubmit() {
      const isValid = await this.$refs.observerNhomChucVu.validate();
      const $vm = this;
      let thuTu = parseInt(this.form.thuTu);
      thuTu = isNaN(thuTu) ? null : thuTu;
      const payload = {
        ...this.form,
        thuTu: thuTu,
      };
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          this.$store
            .dispatch("nhomChucVu/suaNhomChucVu", {
              data: payload,
              onSuccess: $vm.hideModal,
            })
            .then(() => {
              $vm.hideModal();
              $vm.$emit("refreshData");
              this.isLoading = false;
            })
            .catch((err) => {
              this.isLoading = false;
              if (err) showMsgError(err.data.message);
            });
        } else {
          this.$store
            .dispatch("nhomChucVu/themNhomChucVu", {
              data: payload,
              onSuccess: $vm.hideModal,
            })
            .then(() => {
              $vm.hideModal();
              $vm.$emit("refreshData");
              this.isLoading = false;
            })
            .catch((err) => {
              if (err) showMsgError(err.data.message);
              this.isLoading = false;
            });
        }
      }
    },
  },
  watch: {
    isEdit: function () {
      if (this.isEdit) {
        this.form = Object.assign(this.form, this.data);
      } else {
        this.resetForm();
      }
    },
  },
};
</script>


